import { Radio } from "antd";
import styled from "styled-components";

export const RadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
`;
